<div class="p-2">
  <p class="text-[15px] font-bold text-[var(--base-text-dark)] mb-2">BATCH UPDATE SEASON</p>
  <p class="text-[13px] text-[var(--tertiary-text)] mb-5">Are you sure you want to update batch data?</p>
  <div class="flex items-center gap-2.5">
    <button (click)="cancel()"
      class="py-2 px-4 border-[1.5px] border-[var(--app-border)] rounded-lg text-xs font-semibold bg-white text-[var(--base-text-alt-dark)] cursor-pointer hover:border-[var(--primary-dark)] hover:text-[var(--primary-dark)] transition-all">
      CANCEL
    </button>
    <button (click)="save()"
      class="py-2 px-4 border-none rounded-lg text-xs font-semibold bg-[var(--primary-dark)] text-white cursor-pointer hover:opacity-90 transition-all">
      UPDATE
    </button>
  </div>
</div>
